import React, { useEffect, useState } from 'react';
import { Button, Drawer, Form, Input, message, Select, Row, Col } from 'antd';
// import { useGlobalState } from '../../../store/state';
import { GetBankList } from '../../../apis/Brand/Credit/GetBankList';
import { Config } from '../../../Config';
import { UPIValidator } from '../../../utils';

const { Item } = Form;
const { Option } = Select;
const UpdateBankDetailsForm = ({ bankDetails, saveBankDetails }) => {
  const [bankDetailsForm] = Form.useForm();
  const [bankList, setBankList] = useState(null);
  useEffect(() => {
    GetBankList().then((res) =>{
      // console.log("res",India)
      setBankList(res[Config.country]);
    });
  }, []);

  return (
    <Form
      className="pb-3"
      name="bankDetailsForm"
      onFinish={saveBankDetails}
      form={bankDetailsForm}
      // initialValues={{
      //     "accountnumber": bankDetails.accountnumber || undefined,
      //     "accountnumberConfirm": bankDetails.accountnumber || undefined,
      //     "bankname": bankDetails.bankname || undefined,
      //     "branch": bankDetails.branch || undefined,
      //     "ifsc": bankDetails.ifsc || undefined,
      //     "name": bankDetails.name || undefined,
      //     "upi": bankDetails.upi || undefined,
      // }}
    >
      <Row gutter={16}>
        <Col span={12}>
          <Item
            className="my-2"
            name="accountnumber"
            rules={[
              { required: true, message: 'Please enter account number' },
              () => ({
                validator (_, value) {
                  if (value.length < 8) {
                    return Promise.reject(new Error('Need minimum 8 characters'));
                  } else if (value.length > 18) {
                    return Promise.reject(new Error('maximum 18 characters'));
                  } else {
                    return Promise.resolve();
                  }
                },
              }),
            ]}
            hasFeedback
          >
            <Input className="common_input"
              size="large"
              placeholder="Account number"/>
          </Item>
        </Col>
        <Col span={12}>
          <Item
            className="my-2"
            name="accountnumberConfirm"
            dependencies={['accountnumber']}
            hasFeedback
            rules={[
              { required: true, message: 'Please confirm your account number' },
              ({ getFieldValue }) => ({
                validator (_, value) {
                  if (!value || getFieldValue('accountnumber') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Not matching with account number'));
                },
              }),
            ]}
          >
            <Input className="common_input"
              size="large"
              placeholder="Confirm account number"/>
          </Item>
        </Col>
        <Col span={10}>
          <Item
            className="my-2"
            name="bankname"
            rules={[{ required: true, message: 'Please provide bank name' }]}
          >
            <Select className="common_select"
              size="large"
              placeholder="Select your Bank"
              showSearch>
              {
                bankList && Object.entries(bankList).map(([key, value]) =>(
                  <Option key={key}
                    value={key}>{key}</Option>
                ))
              }
            </Select>
          </Item>
        </Col>
        <Col span={7}>
          <Item
            className="my-2"
            name="branch"
          >
            <Input className="common_input"
              size="large"
              placeholder="Branch Name(Optional)"/>
          </Item>
        </Col>
        <Col span={7}>
          <Item
            className="my-2"
            name="ifsc"
            rules={[{ required: true, message: 'Please enter account IFSC' }]}
          >
            <Input className="common_input"
              size="large"
              placeholder="IFSC"/>
          </Item>
        </Col>
        <Col span={10}>
          <Item
            className="my-2"
            name="name"
          >
            <Input className="common_input"
              size="large"
              placeholder="Account holder name(Optional)"/>
          </Item>
        </Col>
        <Col span={8}>
          <Item
            className="my-2"
            name="upi"
            rules={[
              () => ({
                validator (_, value) {
                  const _validate = UPIValidator(value);
                  if (value && !_validate) {
                    return Promise.reject(new Error('Not a valid UPI ID'));
                  } else {
                    return Promise.resolve();
                  }
                },
              }),
            ]}
          >
            <Input className="common_input"
              size="large"
              placeholder="UPI ID(Optional)"/>
          </Item>
        </Col>
        <Col span={6}>
          <Item
            className="my-2"
          >
            <Button htmlType="submit"
              className="common_button w-100">Save Bank Details</Button>
          </Item>
        </Col>
      </Row>

    </Form>
  );
};

export default UpdateBankDetailsForm;
